import React from 'react';
import FirstStepComponent from './first-step-component';
import SecondStepComponent from './second-step-component';
import ThirdStepComponent from './third-step-component';
import config from '../../../generated/config';

const CompanyFormStepsComponent = ({
  updateState,
  cadastroState,
  setCaptcha,
  cnpjRef,
  corporateNameRef,
  fantasyNameRef,
  emailRef,
  zipCodeRef,
  stateRef,
  cityRef,
  addressRef,
  numberRef,
  neighborhoodRef,
  stateRegistryRef,
  phoneRef,
  contactNameRef
}) => {
  const { companyFormStatus } = cadastroState;

  const firstStepRefs = { cnpjRef, corporateNameRef, fantasyNameRef, emailRef };

  const secondStepRefs = { zipCodeRef, stateRef, cityRef, addressRef, numberRef, neighborhoodRef };

  const thirdStepRefs = { stateRegistryRef, phoneRef, contactNameRef };

  switch (companyFormStatus) {
    case 'FIRST_STEP':
      return (
        <>
          <FirstStepComponent
            cadastroState={cadastroState}
            setCaptcha={setCaptcha}
            updateState={updateState}
            {...firstStepRefs}
          />
          <p className="empresaFormSubtitle">{config.signUpScreen.company.formBottomSubtitle}</p>
        </>
      );
    case 'SECOND_STEP':
      return (
        <>
          <FirstStepComponent
            cadastroState={cadastroState}
            setCaptcha={setCaptcha}
            updateState={updateState}
            {...firstStepRefs}
          />
          <SecondStepComponent
            cadastroState={cadastroState}
            updateState={updateState}
            {...secondStepRefs}
          />
          <p className="empresaFormSubtitle">{config.signUpScreen.company.formBottomSubtitle}</p>
        </>
      );
    case 'THIRD_STEP':
      return (
        <>
          <FirstStepComponent
            cadastroState={cadastroState}
            setCaptcha={setCaptcha}
            updateState={updateState}
            {...firstStepRefs}
          />
          <SecondStepComponent
            cadastroState={cadastroState}
            updateState={updateState}
            {...secondStepRefs}
          />
          <ThirdStepComponent
            cadastroState={cadastroState}
            updateState={updateState}
            {...thirdStepRefs}
          />
        </>
      );
    default:
      return null;
  }
};

export default CompanyFormStepsComponent;
